const pubGoodRouter = [
 

    /* 화면명 : 상품 분류체계 등록  : MSM_SA_009  */
    {
        path: "/publish/im/MIM_CL_001", 
        name : 'PUB_MIM_CL_001',
        component: () => import('@/views/publish/im/MIM_CL_001.vue')
    },

    /* 화면명 : 상품 분류체계 조회/수정  : MIM_CL_002  */
    {
        path: "/publish/im/MIM_CL_002", 
        name : 'PUB_MIM_CL_002',
        component: () => import('@/views/publish/im/MIM_CL_002.vue')
    }


           
   
]
export {pubGoodRouter}